var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6778",
    "data-name": "Rectangle 6778",
    width: 24,
    height: 24,
    fill: "#292929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_107",
    "data-name": "Mask Group 107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-location",
    "data-name": "001-location",
    transform: "translate(1.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35455",
    "data-name": "Group 35455",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35454",
    "data-name": "Group 35454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28601",
    "data-name": "Path 28601",
    d: "M21.643,2.973A10.151,10.151,0,0,0,4.315,10.151c0,5.485,5.186,10.047,7.972,12.5.387.341.722.635.988.884a1.749,1.749,0,0,0,2.381,0c.266-.249.6-.543.988-.884,2.786-2.451,7.972-7.013,7.972-12.5A10.085,10.085,0,0,0,21.643,2.973Zm-5.928,18.62c-.4.348-.737.649-1.019.912a.339.339,0,0,1-.462,0c-.282-.263-.623-.564-1.019-.912-2.619-2.3-7.5-6.593-7.5-11.442a8.745,8.745,0,0,1,17.49,0C23.211,15,18.335,19.289,15.716,21.593Z",
    transform: "translate(-4.315)",
    fill: "#292929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35457",
    "data-name": "Group 35457",
    transform: "translate(5.677 5.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35456",
    "data-name": "Group 35456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28602",
    "data-name": "Path 28602",
    d: "M22.036,12.353a4.473,4.473,0,1,0,4.473,4.473A4.478,4.478,0,0,0,22.036,12.353Zm0,7.541A3.067,3.067,0,1,1,25.1,16.826,3.071,3.071,0,0,1,22.036,19.893Z",
    transform: "translate(-17.562 -12.353)",
    fill: "#292929"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contact_location.cf96da515e420852360bf94a2a35ddd4.svg";
export { ForwardRef as ReactComponent };